(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-preview-wrapper"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

    // ---- Desktop: Main Slider ----
    $('.pw-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.pw-slider-nav'
    });

    $('.pw-slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.pw-slider-for',
        dots: false,
        arrows: true,
        focusOnSelect: true,
        prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.71 15.88L10.83 12L14.71 8.11998C15.1 7.72998 15.1 7.09998 14.71 6.70998C14.32 6.31998 13.69 6.31998 13.3 6.70998L8.70998 11.3C8.31998 11.69 8.31998 12.32 8.70998 12.71L13.3 17.3C13.69 17.69 14.32 17.69 14.71 17.3C15.09 16.91 15.1 16.27 14.71 15.88Z" fill="white"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.29006 15.88L13.1701 12L9.29006 8.11998C8.90006 7.72998 8.90006 7.09998 9.29006 6.70998C9.68006 6.31998 10.3101 6.31998 10.7001 6.70998L15.2901 11.3C15.6801 11.69 15.6801 12.32 15.2901 12.71L10.7001 17.3C10.3101 17.69 9.68006 17.69 9.29006 17.3C8.91006 16.91 8.90006 16.27 9.29006 15.88Z" fill="white"/></svg></button>'
    });

    // ---- Desktop: Logo Upload & Name Preview ----
    var desktopLogoDataUrl = null;

    // File selected
    $('#pw-logo-file').on('change', function () {
        var file = this.files[0];
        if (!file) return;
        var reader = new FileReader();
        reader.onload = function (e) {
            desktopLogoDataUrl = e.target.result;
            $('#pw-upload-icon').html('<img src="' + desktopLogoDataUrl + '" style="max-width:40px;max-height:40px;border-radius:4px;object-fit:contain;">');
            $('#pw-upload-title').html('<span style="color:#1F7A8C;">Logo uploaded!</span>');
        };
        reader.readAsDataURL(file);
    });

    // Button click → draw on all slides (logo and text separately)
    $('#pw-personalise-btn').on('click', function () {
        var name = $('#pw-name-input').val().trim();
        if (!name && !desktopLogoDataUrl) {
            alert('Please enter a name or upload a logo to preview.');
            return;
        }
        $('.pw-slider-for .pw-canvas-wrap').each(function () {
            var $wrap = $(this);
            var $img = $wrap.find('.pw-product-img');
            if (!$img.length) return;
            var imgEl = $img[0];
            function doRenderDesktop() {
                drawTextOnCanvas($wrap.find('.pw-text-canvas')[0], imgEl, name);
                drawLogoOnCanvas($wrap.find('.pw-logo-canvas')[0], imgEl, desktopLogoDataUrl);
            }
            if (imgEl.complete && imgEl.naturalWidth > 0) {
                doRenderDesktop();
            } else {
                imgEl.onload = doRenderDesktop;
            }
        });
    });

    // Re-render on slide change
    $('.pw-slider-for').on('afterChange', function () {
        var name = $('#pw-name-input').val().trim();
        if (!name && !desktopLogoDataUrl) return;
        var $wrap = $('.pw-slider-for .slick-current .pw-canvas-wrap');
        if (!$wrap.length) return;
        var $img = $wrap.find('.pw-product-img');
        if (!$img.length) return;
        var imgEl = $img[0];
        function doRenderSlide() {
            drawTextOnCanvas($wrap.find('.pw-text-canvas')[0], imgEl, name);
            drawLogoOnCanvas($wrap.find('.pw-logo-canvas')[0], imgEl, desktopLogoDataUrl);
        }
        if (imgEl.complete && imgEl.naturalWidth > 0) {
            doRenderSlide();
        } else {
            imgEl.onload = doRenderSlide;
        }
    });

    // ============================================================
    // TEXT & LOGO SETTINGS — Edit these to customize appearance
    // ============================================================
    var PW_TEXT_CONFIG = {
        // Desktop text settings
        desktop: {
            fontFamily: 'sans-serif',       // e.g. 'Georgia', 'Arial', 'sans-serif'
            fontWeight: '400',             // 'bold', 'normal', '600' etc.
            fontSizeRatio: 0.02,            // font size as ratio of image width (0.07 = 7%)
            color: '#fff', // text color
            textAlign: 'center',            // 'center', 'left', 'right'
            posX: 0.5,                      // horizontal position (0.5 = center, 0 = left, 1 = right)
            posY: 0.88                      // vertical position (0 = top, 1 = bottom)
        },
        // Mobile popup text settings
        mobile: {
            fontFamily: 'sans-serif',
            fontWeight: '400',
            fontSizeRatio: 0.02,            // slightly larger ratio for smaller canvas
            color: '#fff',
            textAlign: 'center',
            posX: 0.5,
            posY: 0.88
        }
    };

    var PW_LOGO_CONFIG = {
        // Desktop logo settings
        desktop: {
            sizeRatio: 0.28,    // logo width as ratio of image width
            posX: 0.5,          // horizontal center (0.5 = center)
            posY: 0.06          // vertical position from top (0.06 = 6% from top)
        },
        // Mobile popup logo settings
        mobile: {
            sizeRatio: 0.30,
            posX: 0.5,
            posY: 0.06
        }
    };

    // ---- Draw TEXT on pw-text-canvas (Desktop) ----
    function drawTextOnCanvas(canvas, imgEl, name) {
        if (!canvas || !name) return;
        var cfg = PW_TEXT_CONFIG.desktop;
        var w = imgEl.offsetWidth || imgEl.naturalWidth || 300;
        var h = imgEl.offsetHeight || imgEl.naturalHeight || 300;
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, w, h);
        ctx.save();
        ctx.font = cfg.fontWeight + ' ' + Math.round(w * cfg.fontSizeRatio) + 'px ' + cfg.fontFamily;
        ctx.fillStyle = cfg.color;
        ctx.textAlign = cfg.textAlign;
        ctx.shadowColor = cfg.shadowColor;
        ctx.shadowBlur = cfg.shadowBlur;
        ctx.fillText(name, w * cfg.posX, h * cfg.posY);
        ctx.restore();
    }

    // ---- Draw LOGO on pw-logo-canvas (Desktop) ----
    function drawLogoOnCanvas(canvas, imgEl, logoDataUrl) {
        if (!canvas || !logoDataUrl) return;
        var cfg = PW_LOGO_CONFIG.desktop;
        var w = imgEl.offsetWidth || imgEl.naturalWidth || 300;
        var h = imgEl.offsetHeight || imgEl.naturalHeight || 300;
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, w, h);
        var logoImg = new Image();
        logoImg.onload = function () {
            var logoW = Math.round(w * cfg.sizeRatio);
            var logoH = Math.round(logoW * (logoImg.naturalHeight / logoImg.naturalWidth));
            ctx.drawImage(logoImg, Math.round(w * cfg.posX - logoW / 2), Math.round(h * cfg.posY), logoW, logoH);
        };
        logoImg.src = logoDataUrl;
    }

    // ---- Legacy shared function (used by mobile popup) ----
    function drawOnCanvas($wrap, imgSel, canvasSel, name, logoDataUrl) {
        var $img = $wrap.find(imgSel);
        var $canvas = $wrap.find(canvasSel);
        if (!$img.length || !$canvas.length) return;
        var imgEl = $img[0];

        function doRender() {
            var w = imgEl.offsetWidth || imgEl.naturalWidth || 300;
            var h = imgEl.offsetHeight || imgEl.naturalHeight || 300;
            var canvas = $canvas[0];
            canvas.width = w;
            canvas.height = h;
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, w, h);

            if (name) {
                var tcfg = PW_TEXT_CONFIG.mobile;
                ctx.save();
                ctx.font = tcfg.fontWeight + ' ' + Math.round(w * tcfg.fontSizeRatio) + 'px ' + tcfg.fontFamily;
                ctx.fillStyle = tcfg.color;
                ctx.textAlign = tcfg.textAlign;
                ctx.shadowColor = tcfg.shadowColor;
                ctx.shadowBlur = tcfg.shadowBlur;
                ctx.fillText(name, w * tcfg.posX, h * tcfg.posY);
                ctx.restore();
            }

            if (logoDataUrl) {
                var lcfg = PW_LOGO_CONFIG.mobile;
                var logoImg = new Image();
                logoImg.onload = function () {
                    var logoW = Math.round(w * lcfg.sizeRatio);
                    var logoH = Math.round(logoW * (logoImg.naturalHeight / logoImg.naturalWidth));
                    ctx.drawImage(logoImg, Math.round(w * lcfg.posX - logoW / 2), Math.round(h * lcfg.posY), logoW, logoH);
                };
                logoImg.src = logoDataUrl;
            }
        }

        if (imgEl.complete && imgEl.naturalWidth > 0) {
            doRender();
        } else {
            imgEl.onload = doRender;
        }
    }

    // ---- Mobile Personalisation Popup ----
    var $popup = $('#personalisation-popup-overlay');
    var popupSliderReady = false;
    var popupLogoDataUrl = null;

    function initPopupSliders() {
        if (popupSliderReady) return;
        $('.pw-popup-slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.pw-popup-slider-nav'
        });
        $('.pw-popup-slider-nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.pw-popup-slider-for',
            dots: false,
            arrows: true,
            focusOnSelect: true,
            prevArrow: '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7583 14.4084L7.34995 10.0001L11.7583 5.5918" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.2417 5.5918L12.65 10.0001L8.2417 14.4084" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
        });
        popupSliderReady = true;
    }

    $(document).on('click', '.mobile-personalisation-trigger', function (e) {
        e.preventDefault();
        $popup.addClass('active');
        $('body, html').css('overflow', 'hidden');
        initPopupSliders();
        if (popupSliderReady) {
            $('.pw-popup-slider-for, .pw-popup-slider-nav').slick('setPosition');
        }
    });

    $('#personalisation-popup-close').on('click', function () {
        $popup.removeClass('active');
        $('body, html').css('overflow', '');
    });

    $popup.on('click', function (e) {
        if (e.target === this) {
            $popup.removeClass('active');
            $('body, html').css('overflow', '');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $popup.hasClass('active')) {
            $popup.removeClass('active');
            $('body, html').css('overflow', '');
        }
    });

    $('#pw-popup-logo-file').on('change', function () {
        var file = this.files[0];
        if (!file) return;
        var reader = new FileReader();
        reader.onload = function (e) {
            popupLogoDataUrl = e.target.result;
        };
        reader.readAsDataURL(file);
    });

    $('#pw-popup-personalise-btn').on('click', function () {
        var name = $('#pw-popup-name').val().trim();
        if (!name && !popupLogoDataUrl) {
            alert('Please enter a name or upload a logo to preview.');
            return;
        }
        $('.pw-popup-slider-for .pw-popup-canvas-wrap').each(function () {
            var $wrap = $(this);
            var $img = $wrap.find('.pw-popup-product-img');
            if (!$img.length) return;
            var imgEl = $img[0];
            function doRenderPopup() {
                drawPopupTextOnCanvas($wrap.find('.pw-popup-text-canvas')[0], imgEl, name);
                drawPopupLogoOnCanvas($wrap.find('.pw-popup-logo-canvas')[0], imgEl, popupLogoDataUrl);
            }
            if (imgEl.complete && imgEl.naturalWidth > 0) {
                doRenderPopup();
            } else {
                imgEl.onload = doRenderPopup;
            }
        });
    });

    $('.pw-popup-slider-for').on('afterChange', function () {
        var name = $('#pw-popup-name').val().trim();
        if (!name && !popupLogoDataUrl) return;
        var $wrap = $('.pw-popup-slider-for .slick-current .pw-popup-canvas-wrap');
        if (!$wrap.length) return;
        var $img = $wrap.find('.pw-popup-product-img');
        if (!$img.length) return;
        var imgEl = $img[0];
        function doRenderPopupSlide() {
            drawPopupTextOnCanvas($wrap.find('.pw-popup-text-canvas')[0], imgEl, name);
            drawPopupLogoOnCanvas($wrap.find('.pw-popup-logo-canvas')[0], imgEl, popupLogoDataUrl);
        }
        if (imgEl.complete && imgEl.naturalWidth > 0) {
            doRenderPopupSlide();
        } else {
            imgEl.onload = doRenderPopupSlide;
        }
    });

    // ---- Draw TEXT on pw-popup-text-canvas (Mobile Popup) ----
    function drawPopupTextOnCanvas(canvas, imgEl, name) {
        if (!canvas || !name) return;
        var cfg = PW_TEXT_CONFIG.mobile;
        var w = imgEl.offsetWidth || imgEl.naturalWidth || 300;
        var h = imgEl.offsetHeight || imgEl.naturalHeight || 300;
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, w, h);
        ctx.save();
        ctx.font = cfg.fontWeight + ' ' + Math.round(w * cfg.fontSizeRatio) + 'px ' + cfg.fontFamily;
        ctx.fillStyle = cfg.color;
        ctx.textAlign = cfg.textAlign;
        ctx.shadowColor = cfg.shadowColor;
        ctx.shadowBlur = cfg.shadowBlur;
        ctx.fillText(name, w * cfg.posX, h * cfg.posY);
        ctx.restore();
    }

    // ---- Draw LOGO on pw-popup-logo-canvas (Mobile Popup) ----
    function drawPopupLogoOnCanvas(canvas, imgEl, logoDataUrl) {
        if (!canvas || !logoDataUrl) return;
        var cfg = PW_LOGO_CONFIG.mobile;
        var w = imgEl.offsetWidth || imgEl.naturalWidth || 300;
        var h = imgEl.offsetHeight || imgEl.naturalHeight || 300;
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, w, h);
        var logoImg = new Image();
        logoImg.onload = function () {
            var logoW = Math.round(w * cfg.sizeRatio);
            var logoH = Math.round(logoW * (logoImg.naturalHeight / logoImg.naturalWidth));
            ctx.drawImage(logoImg, Math.round(w * cfg.posX - logoW / 2), Math.round(h * cfg.posY), logoW, logoH);
        };
        logoImg.src = logoDataUrl;
    }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabitat-celebrities"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('[data-celebrities-carousel]');

    carousels.forEach((carousel) => {
      const viewport = carousel.querySelector('.rabitat-celebrities__viewport');
      const track = carousel.querySelector('.rabitat-celebrities__track');
      const cards = carousel.querySelectorAll('[data-celebrities-card]');
      const prevBtn = carousel.querySelector('[data-celebrities-prev]');
      const nextBtn = carousel.querySelector('[data-celebrities-next]');

      if (!viewport || !track || cards.length <= 1) return;

      let currentIndex = 0;

      const getSlidesPerView = () => (window.innerWidth <= 768 ? 1 : 3);

      const getMaxIndex = () => Math.max(0, cards.length - getSlidesPerView());

      const updateButtons = () => {
        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();
      };

      const scrollToIndex = (index) => {
        currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
        const card = cards[currentIndex];

        if (card) {
          viewport.scrollTo({
            left: card.offsetLeft - track.offsetLeft,
            behavior: 'smooth',
          });
        }

        updateButtons();
      };

      if (prevBtn) prevBtn.addEventListener('click', () => scrollToIndex(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollToIndex(currentIndex + 1));

      let scrollTicking = false;

      viewport.addEventListener(
        'scroll',
        () => {
          if (scrollTicking) return;
          scrollTicking = true;
          window.requestAnimationFrame(() => {
            scrollTicking = false;
            const scrollLeft = viewport.scrollLeft;
            let nearestIndex = 0;
            let nearestDistance = Infinity;

            cards.forEach((card, index) => {
              const distance = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
              }
            });

            currentIndex = Math.min(nearestIndex, getMaxIndex());
            updateButtons();
          });
        },
        { passive: true }
      );

      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabitat-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function padSlideNumber(value) {
      return String(value).padStart(2, '0');
    }

    function syncHeroVideos(slides, activeIndex) {
      slides.forEach(function (slide, index) {
        slide.querySelectorAll('video').forEach(function (video) {
          if (index === activeIndex) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      });
    }

    function initHeroSlider(slider) {
      if (slider.dataset.heroSliderBound === 'true') return;
      slider.dataset.heroSliderBound = 'true';

      var slides = slider.querySelectorAll('[data-hero-slide]');
      var prevBtn = slider.querySelector('[data-hero-prev]');
      var nextBtn = slider.querySelector('[data-hero-next]');
      var dots = slider.querySelectorAll('[data-hero-dot]');
      var counterCurrent = slider.querySelector('[data-hero-counter-current]');
      var counterTotal = slider.querySelector('[data-hero-counter-total]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = slider.dataset.autoplay === 'true' && !reducedMotion;
      var pauseOnHover = slider.dataset.pauseOnHover === 'true';
      var speed = (parseInt(slider.dataset.autoplaySpeed, 10) || 5) * 1000;
      var transitionSpeed = parseInt(slider.dataset.transitionSpeed, 10) || 750;
      var current = 0;
      var timer = null;
      var transitioning = false;

      if (transitionSpeed > 0) {
        slider.style.setProperty('--hero-transition-speed', reducedMotion ? '0.2s' : transitionSpeed + 'ms');
      }

      if (slides.length === 0) return;

      var updateControls = function () {
        dots.forEach(function (dot, index) {
          var isActive = index === current;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        if (counterCurrent) {
          counterCurrent.textContent = padSlideNumber(current + 1);
        }
      };

      if (counterTotal) {
        counterTotal.textContent = padSlideNumber(slides.length);
      }

      var goTo = function (index) {
        if (index === current || transitioning) return;

        transitioning = true;
        slides[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        syncHeroVideos(slides, current);
        updateControls();

        window.setTimeout(function () {
          transitioning = false;
        }, reducedMotion ? 200 : transitionSpeed);
      };

      var next = function () {
        goTo(current + 1);
      };

      var prev = function () {
        goTo(current - 1);
      };

      var restartAutoplay = function () {
        stopAutoplay();
        startAutoplay();
      };

      if (slides.length > 1) {
        if (prevBtn) {
          prevBtn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            prev();
            restartAutoplay();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            next();
            restartAutoplay();
          });
        }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            goTo(parseInt(dot.dataset.heroDot, 10));
            restartAutoplay();
          });
        });

        var viewport = slider.querySelector('.rabitat-hero-slider__viewport') || slider;

        if (window.initRabitatSliderTouch) {
          window.initRabitatSliderTouch(viewport, {
            onNext: function () {
              next();
              restartAutoplay();
            },
            onPrev: function () {
              prev();
              restartAutoplay();
            },
          });
        }
      }

      var startAutoplay = function () {
        if (!autoplay || slides.length <= 1) return;
        stopAutoplay();
        timer = window.setInterval(next, speed);
      };

      var stopAutoplay = function () {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      if (pauseOnHover) {
        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
      }

      syncHeroVideos(slides, current);
      updateControls();
      startAutoplay();
    }

    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabitat-launches"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sliders = document.querySelectorAll('[data-launches-slider]');

    sliders.forEach((slider) => {
      const slides = slider.querySelectorAll('[data-launches-slide]');
      const prevBtn = slider.querySelector('[data-launches-prev]');
      const nextBtn = slider.querySelector('[data-launches-next]');
      const dots = slider.querySelectorAll('[data-launches-dot]');
      const autoplay = slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speed = (parseInt(slider.dataset.autoplaySpeed, 10) || 6) * 1000;
      let current = 0;
      let timer = null;

      if (slides.length <= 1) return;

      const updateDots = () => {
        dots.forEach((dot, index) => {
          const isActive = index === current;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const goTo = (index) => {
        slides[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        updateDots();
      };

      const next = () => goTo(current + 1);
      const prev = () => goTo(current - 1);

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prev();
          stopAutoplay();
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          next();
          stopAutoplay();
          startAutoplay();
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(parseInt(dot.dataset.launchesDot, 10));
          stopAutoplay();
          startAutoplay();
        });
      });

      const viewport = slider.querySelector('.rabitat-launches__viewport') || slider;

      if (window.initRabitatSliderTouch) {
        window.initRabitatSliderTouch(viewport, {
          onNext: () => {
            next();
            stopAutoplay();
            startAutoplay();
          },
          onPrev: () => {
            prev();
            stopAutoplay();
            startAutoplay();
          },
        });
      }

      const startAutoplay = () => {
        if (!autoplay) return;
        stopAutoplay();
        timer = window.setInterval(next, speed);
      };

      const stopAutoplay = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabitat-press"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('[data-press-carousel]');

    carousels.forEach((carousel) => {
      const viewport = carousel.querySelector('.rabitat-press__viewport');
      const track = carousel.querySelector('.rabitat-press__grid');
      const items = carousel.querySelectorAll('[data-press-item]');
      const prevBtn = carousel.querySelector('[data-press-prev]');
      const nextBtn = carousel.querySelector('[data-press-next]');

      if (!viewport || !track || items.length <= 1) return;

      let currentIndex = 0;

      const isMobile = () => window.innerWidth <= 768;

      const getMaxIndex = () => (isMobile() ? items.length - 1 : 0);

      const updateButtons = () => {
        if (!isMobile()) {
          if (prevBtn) prevBtn.disabled = false;
          if (nextBtn) nextBtn.disabled = false;
          return;
        }

        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= getMaxIndex();
      };

      const scrollToIndex = (index) => {
        if (!isMobile()) return;

        currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
        const item = items[currentIndex];

        if (item) {
          viewport.scrollTo({
            left: item.offsetLeft - track.offsetLeft,
            behavior: 'smooth',
          });
        }

        updateButtons();
      };

      if (prevBtn) prevBtn.addEventListener('click', () => scrollToIndex(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollToIndex(currentIndex + 1));

      let scrollTicking = false;

      viewport.addEventListener(
        'scroll',
        () => {
          if (!isMobile()) return;
          if (scrollTicking) return;
          scrollTicking = true;

          window.requestAnimationFrame(() => {
            scrollTicking = false;
            const scrollLeft = viewport.scrollLeft;
            let nearestIndex = 0;
            let nearestDistance = Infinity;

            items.forEach((item, index) => {
              const distance = Math.abs(item.offsetLeft - track.offsetLeft - scrollLeft);
              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
              }
            });

            currentIndex = nearestIndex;
            updateButtons();
          });
        },
        { passive: true }
      );

      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabitat-search"]) return;
  try {
    
  (function () {
    function initSearchPage(root) {
      if (!root || root.dataset.searchPageBound === 'true') return;
      root.dataset.searchPageBound = 'true';

      var input = root.querySelector('[data-search-page-input]');
      var clearBtn = root.querySelector('[data-search-page-clear]');
      if (!input) return;

      function updateClearButton() {
        if (!clearBtn) return;
        clearBtn.hidden = input.value.trim().length === 0;
      }

      input.addEventListener('input', updateClearButton);

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          updateClearButton();
          input.focus();
        });
      }

      if (!input.value.trim()) {
        input.focus();
      }
    }

    document.querySelectorAll('[data-rabitat-search-page]').forEach(initSearchPage);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-rabitat-search-page]');
      if (root) initSearchPage(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-client-wrapper"] && !Shopify.designMode) return;
  try {
    
// Client Logo Slider
$(document).ready(function () {
    $('.client-wrapper-row').slick({
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 8,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-why-choose"] && !Shopify.designMode) return;
  try {
    
// No JavaScript required for this section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-work-section"] && !Shopify.designMode) return;
  try {
    
// No JavaScript required for this section

  } catch(e) { console.error(e); }
})();
})();
